import { useDynamicEntityStoreContext } from '../contexts';
import { capitaliseString } from '../../utils/StringFormatters';

import TemplateMapper from './TemplateMapper';

export default function SEOSettingsPane() {
  const seoBeingEdited = useDynamicEntityStoreContext((state) => state.seoBeingEdited);
  const seo = useDynamicEntityStoreContext((state) => state.data.seo);

  const updateSeo = useDynamicEntityStoreContext((state) => state.updateSeo);

  const seoItemValue = seo[seoBeingEdited];

  const handleChange = (value) => updateSeo({ [seoBeingEdited]: value });

  return (
    <div className="d-flex flex-column gap-3">
      <h3>Editing SEO {capitaliseString(seoBeingEdited)}</h3>
      <TemplateMapper {...{ handleChange, value: seoItemValue }} />
    </div>
  );
}
